import Seo, { localBusinessSchema } from "@/components/Seo";
import Reveal from "@/components/Reveal";
import EnrollForm from "@/components/EnrollForm";

const FACTS = [
  { l: "Response time", v: "Within 1 business day" },
  { l: "First session", v: "50 minutes" },
  { l: "Insurance", v: "Most major plans" },
  { l: "Telehealth", v: "Available across CT" },
];

export default function Enroll() {
  return (
    <>
      <Seo
        title="New Patient Enrollment — Let Go Wellness, Waterbury, CT"
        description="Become a new patient at Let Go Wellness in Waterbury, CT. Share a few details and a care coordinator will reach out within one business day. HIPAA-protected."
        path="/new-patient"
        jsonLd={localBusinessSchema}
      />
      <section className="border-b border-border">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <Reveal>
            <div className="overline mb-6">New patient enrollment</div>
            <h1 className="max-w-3xl font-serif text-5xl leading-tight text-ink sm:text-6xl">Reach out. We'll meet you <span className="italic text-clay">where you are.</span></h1>
            <p className="mt-6 max-w-xl font-sans text-base leading-relaxed text-ink-soft">Share a few details and one of our care coordinators will call or email within one business day. Everything you share is HIPAA-protected and strictly confidential.</p>
          </Reveal>
          <div className="mt-10 grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-4">
            {FACTS.map((f) => (
              <div key={f.l} className="bg-white p-6"><div className="overline mb-2">{f.l}</div><p className="font-serif text-xl text-ink">{f.v}</p></div>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-white py-20">
        <div className="mx-auto max-w-3xl px-6"><EnrollForm /></div>
      </section>
    </>
  );
}
